export default __webpack_public_path__ + "static/media/hn-mynumber.849ef88c.png";